module.exports = __webpack_public_path__ + "static/media/past-white.0e6c63b1.svg";